module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    class: {
      'is-active': _vm.companyAppViewModal
    },
    attrs: {
      "id": "company-app-view-template"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "modalBody",
    staticClass: "modal-body-container ht-full"
  }, [_c('div', {
    staticClass: "tab-wid-full tab-container-full"
  }, [_c('div', {
    staticClass: "tab-head"
  }, [_c('div', {
    staticClass: "tab-menu-wrap",
    attrs: {
      "role": "tablist"
    }
  }, [_c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.showTab === 'basicInfo'
    },
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.showTab === 'basicInfo',
      "data-tab": "basicInfo"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('basicInfo')
      }
    }
  }, [_vm._v("\n              기본정보\n              "), (_vm.showTab === 'basicInfo') ? _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("선택됨")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "tab-menu",
    class: {
      'is-active': _vm.showTab === 'additionalInfo'
    },
    attrs: {
      "type": "button",
      "role": "tab",
      "aria-selected": _vm.showTab === 'additionalInfo',
      "data-tab": "additionalInfo"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('additionalInfo')
      }
    }
  }, [_vm._v("\n              추가 입력 사항\n              "), (_vm.showTab === 'additionalInfo') ? _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("선택됨")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content__wrap"
  }, [_c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.showTab === 'basicInfo'
    },
    attrs: {
      "id": "basicInfo"
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title mt-40"
  }, [_vm._v("기본정보")]), _vm._v(" "), _c('div', {
    staticClass: "mo-type"
  }, [_c('div', {
    staticClass: "table-wrap no-line-mg"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("기업 정보 테이블")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center height-100p"
  }, [_vm._v("\n                          " + _vm._s(_vm.editableData.COMPNM || '-') + "\n                        ")])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center height-100p"
  }, [_vm._v("\n                          " + _vm._s(_vm.editableData.RPSTR_NM || '-') + "\n                        ")])])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center height-100p"
  }, [_vm._v("\n                          " + _vm._s(_vm.editableData.COM_NO || '-') + "\n                        ")])])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm.editableData.ZIPCODE || ''))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.editableData.ADDR || ''))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.editableData.ADDR_DTL || ''))])])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area input-size-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.MAIN_BSNS_DESC),
      expression: "editableData.MAIN_BSNS_DESC"
    }],
    ref: "firstInput",
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "주요사업"
    },
    domProps: {
      "value": (_vm.editableData.MAIN_BSNS_DESC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "MAIN_BSNS_DESC", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center"
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.FLTM_WRKR_CNT),
      expression: "editableData.FLTM_WRKR_CNT"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "상시근로자수"
    },
    domProps: {
      "value": (_vm.editableData.FLTM_WRKR_CNT)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "FLTM_WRKR_CNT", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4",
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("명")])])])]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center flex-wrap-wrap gap8"
  }, [_c('span', {
    staticClass: "font-body-style4"
  }, [_vm._v("전년도 기준")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.SALAMT),
      expression: "editableData.SALAMT"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "매출액 (전년도 기준)"
    },
    domProps: {
      "value": (_vm.editableData.SALAMT)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "SALAMT", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4",
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("천원")])])])]), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center flex-wrap-wrap gap8"
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.TEL_1),
      expression: "editableData.TEL_1"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "maxlength": "3",
      "placeholder": "02",
      "title": "전화번호 앞자리"
    },
    domProps: {
      "value": (_vm.editableData.TEL_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "TEL_1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.TEL_2),
      expression: "editableData.TEL_2"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "maxlength": "4",
      "placeholder": "1234",
      "title": "전화번호 중간자리"
    },
    domProps: {
      "value": (_vm.editableData.TEL_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "TEL_2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.TEL_3),
      expression: "editableData.TEL_3"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "maxlength": "4",
      "placeholder": "5678",
      "title": "전화번호 뒷자리"
    },
    domProps: {
      "value": (_vm.editableData.TEL_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "TEL_3", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center flex-wrap-wrap gap8"
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.HP_1),
      expression: "editableData.HP_1"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "휴대폰 앞자리"
    },
    domProps: {
      "value": (_vm.editableData.HP_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "HP_1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.HP_2),
      expression: "editableData.HP_2"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "휴대폰 중간자리"
    },
    domProps: {
      "value": (_vm.editableData.HP_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "HP_2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.HP_3),
      expression: "editableData.HP_3"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "휴대폰 뒷자리"
    },
    domProps: {
      "value": (_vm.editableData.HP_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "HP_3", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("팩스번호")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center flex-wrap-wrap gap8"
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.FAX_1),
      expression: "editableData.FAX_1"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "팩스번호 앞자리"
    },
    domProps: {
      "value": (_vm.editableData.FAX_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "FAX_1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.FAX_2),
      expression: "editableData.FAX_2"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "팩스번호 중간자리"
    },
    domProps: {
      "value": (_vm.editableData.FAX_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "FAX_2", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4"
  }, [_vm._v("-")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.FAX_3),
      expression: "editableData.FAX_3"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "팩스번호 뒷자리"
    },
    domProps: {
      "value": (_vm.editableData.FAX_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "FAX_3", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tr', [_vm._m(12), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area input-size-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.CHARGR_NM),
      expression: "editableData.CHARGR_NM"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "담당자명"
    },
    domProps: {
      "value": (_vm.editableData.CHARGR_NM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "CHARGR_NM", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_vm._m(13), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-group email-group"
  }, [_c('div', {
    staticClass: "items1"
  }, [_c('div', {
    staticClass: "input-area wid200"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailLocal),
      expression: "emailLocal"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "placeholder": "1234",
      "title": "이메일 계정"
    },
    domProps: {
      "value": (_vm.emailLocal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailLocal = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dash"
  }, [_vm._v("@")])]), _vm._v(" "), _c('div', {
    staticClass: "items2"
  }, [_c('div', {
    staticClass: "input-area wid200"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailDomain),
      expression: "emailDomain"
    }],
    attrs: {
      "disabled": !_vm.isEditMode,
      "title": "이메일 도메인 선택"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.emailDomain = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onEmailDomainChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("이메일 도메인 선택")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "naver.com"
    }
  }, [_vm._v("naver.com")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hanmail.net"
    }
  }, [_vm._v("hanmail.net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "daum.net"
    }
  }, [_vm._v("daum.net")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gmail.com"
    }
  }, [_vm._v("gmail.com")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google.com"
    }
  }, [_vm._v("google.com")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nate.com"
    }
  }, [_vm._v("nate.com")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yahoo.com"
    }
  }, [_vm._v("yahoo.com")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "paran.com"
    }
  }, [_vm._v("paran.com")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "korea.com"
    }
  }, [_vm._v("korea.com")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "freechal.com"
    }
  }, [_vm._v("freechal.com")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "etc"
    }
  }, [_vm._v("직접입력")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emailDomain === 'etc'),
      expression: "emailDomain === 'etc'"
    }],
    staticClass: "input-area wid200"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailDirectDomain),
      expression: "emailDirectDomain"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "placeholder": "email.com",
      "title": "이메일 도메인 (직접입력)"
    },
    domProps: {
      "value": (_vm.emailDirectDomain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailDirectDomain = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("홈페이지")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "input-area input-size-md"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableData.HOMEPG),
      expression: "editableData.HOMEPG"
    }],
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "홈페이지"
    },
    domProps: {
      "value": (_vm.editableData.HOMEPG)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableData, "HOMEPG", $event.target.value)
      }
    }
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    class: {
      'is-active': _vm.showTab === 'additionalInfo'
    },
    attrs: {
      "id": "additionalInfo"
    }
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('h3', {
    staticClass: "section-title mt-40"
  }, [_vm._v("신청사항")]), _vm._v(" "), _c('div', {
    staticClass: "mo-type"
  }, [_c('div', {
    staticClass: "table-wrap no-line-mg"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("신청사항 정보 테이블")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(16), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center"
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableAdditionalData.APP_PPL),
      expression: "editableAdditionalData.APP_PPL"
    }],
    ref: "firstInputAdditional",
    attrs: {
      "type": "text",
      "disabled": !_vm.isEditMode,
      "title": "신청인원"
    },
    domProps: {
      "value": (_vm.editableAdditionalData.APP_PPL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableAdditionalData, "APP_PPL", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4",
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("명")])])])]), _vm._v(" "), _c('tr', [_vm._m(17), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "flex align-items-center flex-wrap-wrap gap8"
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableAdditionalData.WORK_PD_ST),
      expression: "editableAdditionalData.WORK_PD_ST"
    }],
    attrs: {
      "type": "date",
      "disabled": !_vm.isEditMode,
      "title": "근무(활동)기간 - 시작"
    },
    domProps: {
      "value": (_vm.editableAdditionalData.WORK_PD_ST)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableAdditionalData, "WORK_PD_ST", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-body-style4",
    staticStyle: {
      "margin-left": "8px",
      "margin-right": "8px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('div', {
    staticClass: "input-area"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableAdditionalData.WORK_PD_ED),
      expression: "editableAdditionalData.WORK_PD_ED"
    }],
    attrs: {
      "type": "date",
      "disabled": !_vm.isEditMode,
      "title": "근무(활동)기간 - 종료"
    },
    domProps: {
      "value": (_vm.editableAdditionalData.WORK_PD_ED)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableAdditionalData, "WORK_PD_ED", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tr', [_vm._m(18), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "font-body-style4"
  }, [_vm._v("\n                          활동(근무)이 만족스러운 경우, (기업 부담의) 계속 고용을 할 의향이 있습니까?\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "radio-group mt-8 height-fit"
  }, [_c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "CTNU_EMPLYM_YN_Y"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableAdditionalData.CTNU_EMPLYM_YN),
      expression: "editableAdditionalData.CTNU_EMPLYM_YN"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "radio",
      "id": "CTNU_EMPLYM_YN_Y",
      "name": "CTNU_EMPLYM_YN",
      "value": "Y",
      "disabled": !_vm.isEditMode,
      "title": "계속 고용 여부 예 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.editableAdditionalData.CTNU_EMPLYM_YN, "Y")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editableAdditionalData, "CTNU_EMPLYM_YN", "Y")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n                            예\n                          ")]), _vm._v(" "), (_vm.editableAdditionalData.CTNU_EMPLYM_YN === 'Y') ? _c('div', {
    staticClass: "input-area"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableAdditionalData.CTNU_EMPLYM_PPL),
      expression: "editableAdditionalData.CTNU_EMPLYM_PPL"
    }],
    attrs: {
      "disabled": !_vm.isEditMode,
      "title": "계속고용 인원 선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editableAdditionalData, "CTNU_EMPLYM_PPL", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("계속고용 인원 선택")]), _vm._v(" "), _vm._l((_vm.getEmploymentCountOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                " + _vm._s(option.text) + "\n                              ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "radio-item",
    attrs: {
      "for": "CTNU_EMPLYM_YN_N"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableAdditionalData.CTNU_EMPLYM_YN),
      expression: "editableAdditionalData.CTNU_EMPLYM_YN"
    }],
    staticClass: "sr-only",
    attrs: {
      "type": "radio",
      "id": "CTNU_EMPLYM_YN_N",
      "name": "CTNU_EMPLYM_YN",
      "value": "N",
      "disabled": !_vm.isEditMode,
      "title": "계속 고용 여부 아니요 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.editableAdditionalData.CTNU_EMPLYM_YN, "N")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editableAdditionalData, "CTNU_EMPLYM_YN", "N")
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "custom-radio"
  }), _vm._v("\n                            아니요\n                          ")])])])])])])])])]), _vm._v(" "), ((_vm.appData.appActcompJob && _vm.appData.appActcompJob.length > 0) || (_vm.editableJobs && _vm.editableJobs.length > 0)) ? _c('div', _vm._l(((_vm.isEditMode ? _vm.editableJobs : _vm.appData.appActcompJob)), function(job, index) {
    return _c('div', {
      key: _vm.isEditMode ? index : job.SEQ,
      staticClass: "form-section mt-32 job-info-section"
    }, [_c('h3', {
      staticClass: "section-title mt-40"
    }, [_vm._v("활동내용 " + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "mo-type"
    }, [_c('div', {
      staticClass: "table-wrap no-line-mg"
    }, [_c('table', {
      staticClass: "table-body-only"
    }, [_c('caption', [_vm._v("활동내용 " + _vm._s(index + 1) + " 표")]), _vm._v(" "), _vm._m(19, true), _vm._v(" "), _vm._m(20, true), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(21, true), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-right": "16px"
      }
    }, [_c('div', {
      staticClass: "input-area flex-wrap-wrap gap8"
    }, [(_vm.isEditMode && (_vm.isMetadataLoaded || _vm.isLoadingMetadata)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.JOB_CD_NM),
        expression: "job.JOB_CD_NM"
      }],
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "title": "직무 선택",
        "disabled": _vm.isLoadingMetadata
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(job, "JOB_CD_NM", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateJobCode(job)
        }]
      }
    }, [(_vm.isLoadingMetadata) ? _c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("로딩 중...")]) : _c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("직무를 선택하세요")]), _vm._v(" "), _vm._l((_vm.formMetadata.jobCodes), function(jobCode) {
      return (!_vm.isLoadingMetadata) ? _c('option', {
        key: jobCode.CD,
        domProps: {
          "value": jobCode.CD_NM
        }
      }, [_vm._v("\n                                " + _vm._s(jobCode.CD_NM) + "\n                              ")]) : _vm._e()
    })], 2) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.JOB_CD_NM),
        expression: "job.JOB_CD_NM"
      }],
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "type": "text",
        "readonly": "",
        "title": "상세직무"
      },
      domProps: {
        "value": (job.JOB_CD_NM)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "JOB_CD_NM", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.JOB_DTL_NM),
        expression: "job.JOB_DTL_NM"
      }],
      staticStyle: {
        "width": "148px"
      },
      attrs: {
        "type": "text",
        "disabled": !_vm.isEditMode,
        "title": "상세직무명"
      },
      domProps: {
        "value": (job.JOB_DTL_NM)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "JOB_DTL_NM", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _vm._m(22, true), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-area"
    }, [(_vm.isEditMode && (_vm.isMetadataLoaded || _vm.isLoadingMetadata)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.WISH_PPL),
        expression: "job.WISH_PPL"
      }],
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "title": "희망인원 선택",
        "disabled": _vm.isLoadingMetadata
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(job, "WISH_PPL", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [(_vm.isLoadingMetadata) ? _c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("로딩 중...")]) : _c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("인원을 선택하세요")]), _vm._v(" "), _vm._l((_vm.formMetadata.hopeCountOptions), function(option) {
      return (!_vm.isLoadingMetadata) ? _c('option', {
        key: option.value,
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                                " + _vm._s(option.text) + "\n                              ")]) : _vm._e()
    })], 2) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.WISH_PPL),
        expression: "job.WISH_PPL"
      }],
      staticStyle: {
        "width": "160px"
      },
      attrs: {
        "type": "text",
        "readonly": "",
        "title": "희망인원"
      },
      domProps: {
        "value": (job.WISH_PPL)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "WISH_PPL", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_vm._m(23, true), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "input-area"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.JOB_DTL_DESC),
        expression: "job.JOB_DTL_DESC"
      }],
      attrs: {
        "type": "text",
        "disabled": !_vm.isEditMode,
        "title": "업무내용"
      },
      domProps: {
        "value": (job.JOB_DTL_DESC)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "JOB_DTL_DESC", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_vm._m(24, true), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "input-area"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.ESSNTL_QUALF_DESC),
        expression: "job.ESSNTL_QUALF_DESC"
      }],
      attrs: {
        "type": "text",
        "disabled": !_vm.isEditMode,
        "title": "자격사항(필수)"
      },
      domProps: {
        "value": (job.ESSNTL_QUALF_DESC)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "ESSNTL_QUALF_DESC", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_vm._m(25, true), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "input-area"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.PVLTRT_QUALF_DESC),
        expression: "job.PVLTRT_QUALF_DESC"
      }],
      attrs: {
        "type": "text",
        "disabled": !_vm.isEditMode,
        "title": "우대사항(우대)"
      },
      domProps: {
        "value": (job.PVLTRT_QUALF_DESC)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "PVLTRT_QUALF_DESC", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_vm._m(26, true), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "input-area"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.EXPRNC_MATTER),
        expression: "job.EXPRNC_MATTER"
      }],
      attrs: {
        "type": "text",
        "disabled": !_vm.isEditMode,
        "title": "경력사항"
      },
      domProps: {
        "value": (job.EXPRNC_MATTER)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "EXPRNC_MATTER", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_vm._m(27, true), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      staticClass: "flex align-items-center flex-wrap-wrap gap8"
    }, [_c('div', {
      staticClass: "input-area",
      staticStyle: {
        "flex-grow": "1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.ZIPCODE),
        expression: "job.ZIPCODE"
      }],
      attrs: {
        "type": "text",
        "disabled": !_vm.isEditMode,
        "placeholder": "우편번호",
        "title": "우편번호"
      },
      domProps: {
        "value": (job.ZIPCODE)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "ZIPCODE", $event.target.value)
        }, function($event) {
          return _vm.handleAddressChange(index)
        }]
      }
    })]), _vm._v(" "), (_vm.isEditMode) ? _c('button', {
      staticClass: "btn btn-primary btn-form-size",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.searchAddress(index)
        }
      }
    }, [_vm._v("\n                              주소검색\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
      staticClass: "check-wrap",
      staticStyle: {
        "margin-left": "8px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.isUseCorporateAddress),
        expression: "job.isUseCorporateAddress"
      }],
      staticClass: "sr-only",
      attrs: {
        "type": "checkbox",
        "id": ("same_company_addr_" + index),
        "title": "기업 소재지와 동일"
      },
      domProps: {
        "checked": Array.isArray(job.isUseCorporateAddress) ? _vm._i(job.isUseCorporateAddress, null) > -1 : (job.isUseCorporateAddress)
      },
      on: {
        "change": [function($event) {
          var $$a = job.isUseCorporateAddress,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(job, "isUseCorporateAddress", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(job, "isUseCorporateAddress", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(job, "isUseCorporateAddress", $$c)
          }
        }, function($event) {
          return _vm.copyCorporateAddress(index)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("same_company_addr_" + index)
      }
    }, [_c('span', [_vm._v("기업 소재지와 동일")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flex mt-8",
      staticStyle: {
        "gap": "8px"
      }
    }, [_c('div', {
      staticClass: "input-area",
      staticStyle: {
        "flex-grow": "1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.ADDR),
        expression: "job.ADDR"
      }],
      attrs: {
        "type": "text",
        "disabled": !_vm.isEditMode,
        "placeholder": "기본주소",
        "title": "기본주소"
      },
      domProps: {
        "value": (job.ADDR)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "ADDR", $event.target.value)
        }, function($event) {
          return _vm.handleAddressChange(index)
        }]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "input-area",
      staticStyle: {
        "flex-grow": "1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (job.ADDR_DTL),
        expression: "job.ADDR_DTL"
      }],
      attrs: {
        "type": "text",
        "disabled": !_vm.isEditMode,
        "placeholder": "상세주소",
        "title": "상세주소"
      },
      domProps: {
        "value": (job.ADDR_DTL)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(job, "ADDR_DTL", $event.target.value)
        }, function($event) {
          return _vm.handleAddressChange(index)
        }]
      }
    })])])])])])]), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
      staticClass: "button-area tbl",
      staticStyle: {
        "padding-right": "16px"
      }
    }, [_c('button', {
      staticClass: "btn btn-xsm btn-primary job-info-add-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.addJobSection
      }
    }, [_vm._v("\n                        추가\n                      ")]), _vm._v(" "), (index > 0) ? _c('button', {
      staticClass: "btn btn-xsm btn-secondary job-info-remove-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeJobSection(index)
        }
      }
    }, [_vm._v("\n                        삭제\n                      ")]) : _vm._e()]) : _vm._e()])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-section mt-32"
  }, [_c('h3', {
    staticClass: "section-title mt-40"
  }, [_vm._v("운영계획")]), _vm._v(" "), _c('div', {
    staticClass: "textarea-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editableAdditionalData.OPER_PLAN_DESC),
      expression: "editableAdditionalData.OPER_PLAN_DESC"
    }],
    attrs: {
      "maxlength": "1500",
      "disabled": !_vm.isEditMode,
      "title": "운영계획"
    },
    domProps: {
      "value": (_vm.editableAdditionalData.OPER_PLAN_DESC)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editableAdditionalData, "OPER_PLAN_DESC", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.appData.appInfoFile && _vm.appData.appInfoFile.length > 0) ? _c('div', {
    staticClass: "form-section mt-32"
  }, [_c('h3', {
    staticClass: "section-title mt-40"
  }, [_vm._v("첨부파일 등록")]), _vm._v(" "), _c('ul', {
    staticClass: "check-list"
  }, _vm._l((_vm.appData.appInfoFile), function(file, index) {
    return _c('li', {
      key: file.ATTCH_FILE_INFO_NO || index,
      attrs: {
        "data-attch-file-info-no": _vm.getFileId(file, index)
      }
    }, [_c('div', {
      staticClass: "tit"
    }, [_vm._v(_vm._s(file.ATTCH_FILE_DESC || '첨부파일')), (file.FILE_INFO_YN === 'Y') ? _c('span', {
      staticClass: "must"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "file-input-wrapper",
      staticStyle: {
        "padding-right": "16px"
      }
    }, [(!_vm.isEditMode) ? _c('a', {
      style: ({
        cursor: file.REALFILENM ? 'pointer' : 'text'
      }),
      attrs: {
        "href": "javascript:void(0)",
        "title": "{{ file.REALFILENM || '-' }}"
      },
      on: {
        "click": function($event) {
          return _vm.downloadFile(file)
        }
      }
    }, [_vm._v(_vm._s(file.REALFILENM || '-'))]) : [_c('input', {
      staticStyle: {
        "width": "100%",
        "opacity": "0",
        "position": "absolute",
        "cursor": "pointer"
      },
      attrs: {
        "type": "file",
        "id": ("ATTACH_FILE_" + (_vm.getFileId(file, index))),
        "title": (file.ATTCH_FILE_DESC || '첨부파일') + ' 파일 선택',
        "tabindex": "-1"
      },
      on: {
        "change": function($event) {
          _vm.handleFileChange(_vm.getFileId(file, index), $event)
        }
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "text",
        "id": ("ATTACH_FILE_" + (_vm.getFileId(file, index)) + "_NAME"),
        "placeholder": "첨부파일을 선택하세요.",
        "readonly": "",
        "title": (file.ATTCH_FILE_DESC || '첨부파일') + ' 파일명'
      },
      domProps: {
        "value": _vm.getFileName(_vm.getFileId(file, index))
      }
    }), _vm._v(" "), (!_vm.hasFile(_vm.getFileId(file, index))) ? _c('button', {
      staticClass: "btn-file-upload",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.triggerFileInput(_vm.getFileId(file, index))
        }
      }
    }, [_vm._v("\n                        파일추가\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.hasFile(_vm.getFileId(file, index))) ? _c('button', {
      staticClass: "btn btn-secondary btn-sm remove-file-btn",
      staticStyle: {
        "position": "relative",
        "margin-left": "5px",
        "min-width": "83px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeAttachmentFile(_vm.getFileId(file, index))
        }
      }
    }, [_vm._v("\n                        제거\n                      ")]) : _vm._e()]], 2)])
  }), 0)]) : _vm._e(), _vm._v(" "), ((_vm.appData.annSubInfoList && _vm.appData.annSubInfoList.length > 0) || (_vm.editableSubInfoList && _vm.editableSubInfoList.length > 0)) ? _c('div', _vm._l(((_vm.isEditMode ? _vm.editableSubInfoList : _vm.appData.annSubInfoList)), function(subInfo, index) {
    return _c('div', {
      key: _vm.isEditMode ? index : subInfo.RECANNSUBINFO_NO,
      staticClass: "form-section mt-32"
    }, [_c('h3', {
      staticClass: "section-title mt-40"
    }, [_vm._v("추가 입력 내용" + _vm._s(subInfo.SEQ)), (subInfo.ESSNTL_YN === 'Y') ? _c('span', {
      staticClass: "must"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "table-wrap no-line-mg"
    }, [_c('table', {
      staticClass: "table-body-only"
    }, [_c('caption', [_vm._v("추가 입력 내용 표" + _vm._s(subInfo.SEQ))]), _vm._v(" "), _vm._m(28, true), _vm._v(" "), _vm._m(29, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("질문")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "white-space": "pre-line"
      }
    }, [_vm._v(_vm._s(subInfo.QST))])]), _vm._v(" "), _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("답변")]), _vm._v(" "), _c('td', [(subInfo.INFOCD === 'IN34004') ? _c('div', {
      staticClass: "radio-group"
    }, _vm._l((_vm.parseOptions(subInfo.QST_EX)), function(option, optIndex) {
      return _c('label', {
        key: optIndex,
        staticClass: "radio-item"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (subInfo.ANSWER),
          expression: "subInfo.ANSWER"
        }],
        staticClass: "sr-only",
        attrs: {
          "type": "radio",
          "disabled": !_vm.isEditMode,
          "title": "선택 선택"
        },
        domProps: {
          "value": option,
          "checked": _vm._q(subInfo.ANSWER, option)
        },
        on: {
          "change": function($event) {
            return _vm.$set(subInfo, "ANSWER", option)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "custom-radio"
      }), _vm._v("\n                            " + _vm._s(option) + "\n                          ")])
    }), 0) : (subInfo.INFOCD === 'IN34003') ? _c('div', {
      staticClass: "check-wrap"
    }, [_vm._l((_vm.parseOptions(subInfo.QST_EX)), function(option, optIndex) {
      return [_c('input', {
        staticClass: "sr-only",
        attrs: {
          "type": "checkbox",
          "id": ("checkbox_" + (subInfo.RECANNSUBINFO_NO || subInfo.recannsubinfoNo) + "_" + optIndex),
          "disabled": !_vm.isEditMode,
          "title": (option + " 선택")
        },
        domProps: {
          "checked": _vm.isOptionChecked(subInfo, option)
        },
        on: {
          "change": function($event) {
            return _vm.updateCheckboxAnswer(subInfo, option, $event)
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": ("checkbox_" + (subInfo.RECANNSUBINFO_NO || subInfo.recannsubinfoNo) + "_" + optIndex)
        }
      }, [_c('span', [_vm._v(_vm._s(option))])]), _vm._v(" "), (optIndex < _vm.parseOptions(subInfo.QST_EX).length - 1) ? _c('br', {
        staticStyle: {
          "margin-bottom": "8px"
        }
      }) : _vm._e()]
    })], 2) : (subInfo.INFOCD === 'IN34002') ? _c('div', {
      staticClass: "input-area"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (subInfo.ANSWER),
        expression: "subInfo.ANSWER"
      }],
      attrs: {
        "type": "text",
        "maxlength": "200",
        "disabled": !_vm.isEditMode,
        "title": "답변(단문형)"
      },
      domProps: {
        "value": (subInfo.ANSWER)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(subInfo, "ANSWER", $event.target.value)
        }
      }
    })]) : (subInfo.INFOCD === 'IN34001') ? _c('div', {
      staticClass: "textarea-wrap"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (subInfo.ANSWER),
        expression: "subInfo.ANSWER"
      }],
      attrs: {
        "maxlength": "2000",
        "rows": "5",
        "disabled": !_vm.isEditMode,
        "title": "답변(장문형)",
        "name": "answer-sentence"
      },
      domProps: {
        "value": (subInfo.ANSWER)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(subInfo, "ANSWER", $event.target.value)
        }
      }
    })]) : _vm._e()])])])])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.hasAnyAdditionalContent) ? _c('div', {
    staticClass: "empty-content-message",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "min-height": "200px"
    }
  }, [_vm._m(30), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "18px",
      "color": "#333",
      "font-weight": "500",
      "line-height": "1.5"
    }
  }, [_vm._v("\n                이 공고는 추가 입력사항이 없는 공고입니다.\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.shouldShowPublicMyData) ? _c('div', {
    staticClass: "box-type2 mt-32",
    attrs: {
      "id": "publicMyDataSection"
    }
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("공공마이데이터")]), _vm._v(" "), _vm._m(31), _vm._v(" "), (!_vm.isEditMode && _vm.hasPublicMyData) ? _c('div', {
    staticClass: "form-section mt-16 mydata-info-section"
  }, [_c('ul', {
    staticClass: "mydata-example-wrapper type2"
  }, [(_vm.publicMyData.L001) ? _c('li', [_vm._v(_vm._s(_vm.publicMyData.L001))]) : _vm._e(), _vm._v(" "), (_vm.publicMyData.L022) ? _c('li', [_vm._v(_vm._s(_vm.publicMyData.L022))]) : _vm._e(), _vm._v(" "), (_vm.publicMyData.L026) ? _c('li', [_vm._v(_vm._s(_vm.publicMyData.L026))]) : _vm._e(), _vm._v(" "), (_vm.publicMyData.L268) ? _c('li', [_vm._v(_vm._s(_vm.publicMyData.L268))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
    staticClass: "button-area mt-16 fl-start"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-xsm",
    attrs: {
      "href": "javascript:void(0)",
      "id": "mddsApplicationBtn",
      "title": "신청하기"
    },
    on: {
      "click": function($event) {
        return _vm.openMddsInPopup()
      }
    }
  }, [_vm._v("신청하기")])]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.applicableYn === 'Y' && _vm.isEditMode) ? _c('button', {
    staticClass: "btn btn-primary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveAllChanges
    }
  }, [_vm._v("\n        저장\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        닫기\n      ")]), _vm._v(" "), (_vm.applicableYn === 'Y' && !_vm.isEditMode) ? _c('button', {
    staticClass: "btn btn-primary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modify
    }
  }, [_c('i', {
    staticClass: "ico ico-pen-wt"
  }), _vm._v("\n        수정하기\n      ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("기업 신청 정보 조회")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("기업명"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("대표자명"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("사업자등록번호"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("소재지"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("주요사업"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("상시근로자수"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("매출액"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("전화번호"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("휴대폰"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("담당자명"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("이메일"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("신청인원"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("근무(활동)기간"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("계속고용여부"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "348px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col'), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("직무명"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("희망인원"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("업무내용"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("자격사항(필수)"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("우대사항(우대)"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("경력사항"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("근무장소"), _c('span', {
    staticClass: "must"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": "48px",
      "color": "#999",
      "margin-bottom": "20px",
      "opacity": "0.7"
    }
  }, [_c('i', {
    staticClass: "ico ico-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "description bt-line"
  }, [_vm._v("\n                공공마이데이터 인증과정을 통해 각종 증빙서류들을 파일첨부없이 증빙합니다. "), _c('br'), _vm._v("\n                (4대 사회보험료 완납증명서, 사업자등록증명, 표준재무제표증명(개인), 주민등록표 등초본)\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626045d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/member/APP/CompanyAppView.vue
// module id = 1425
// module chunks = 6